import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _RECORD_FILTERS, _CATEGORY_MATCHERS;

import { NoteType } from 'src/types/diet';
export var CLASS_STATE_MAPPING = {
  created: {
    key: 'created',
    color: '',
    text: 'classState.created'
  },
  started: {
    key: 'started',
    color: 'white',
    bg: 'green.500',
    text: 'classState.started'
  },
  finished: {
    key: 'finished',
    color: '',
    text: 'classState.finished'
  },
  archived: {
    key: 'archived',
    color: '',
    text: 'classState.archived'
  }
};
export var RELATIONSHIP_CONNECTED_STATUS = 'connect';
export var SUBSCRIPTIONS_STATE_MAPPING = {
  started: {
    key: 'started',
    color: 'white',
    bg: 'green.500',
    text: 'subscriptionState.started'
  },
  left: {
    key: 'left',
    color: 'white',
    bg: 'red.400',
    text: 'subscriptionState.left'
  },
  created: {
    key: 'created',
    color: '',
    text: 'subscriptionState.created'
  },
  finished: {
    key: 'finished',
    color: '',
    text: 'subscriptionState.finished'
  },
  archived: {
    key: 'archived',
    color: '',
    text: 'subscriptionState.archived'
  }
};
export var HEALTH_PRODUCT_CLASS_NAME = '保健品方案';
export var TODO_TYPES = {
  diet: {
    text: '飲食紀錄',
    key: 'diet'
  },
  body: {
    text: '身體數據',
    key: 'body'
  },
  chat: {
    text: '聊天室',
    key: 'chat'
  }
};
export var TODO_FILTERS = {
  all: 'all',
  unfinished: 'unfinished',
  diet: 'diet',
  body: 'body',
  other: 'other'
};
export var RECORD_FILTER_TYPE;

(function (RECORD_FILTER_TYPE) {
  RECORD_FILTER_TYPE["body"] = "body";
  RECORD_FILTER_TYPE[RECORD_FILTER_TYPE["food"] = NoteType.FoodNote] = "food";
  RECORD_FILTER_TYPE[RECORD_FILTER_TYPE["move"] = NoteType.MoveNote] = "move";
  RECORD_FILTER_TYPE[RECORD_FILTER_TYPE["water"] = NoteType.WaterNote] = "water";
  RECORD_FILTER_TYPE[RECORD_FILTER_TYPE["life"] = NoteType.LifeNote] = "life";
  RECORD_FILTER_TYPE[RECORD_FILTER_TYPE["stool"] = NoteType.StoolNote] = "stool";
})(RECORD_FILTER_TYPE || (RECORD_FILTER_TYPE = {}));

export var RECORD_FILTERS = (_RECORD_FILTERS = {}, _defineProperty(_RECORD_FILTERS, NoteType.FoodNote, {
  noteType: NoteType.FoodNote,
  i18n: 'client_mgmt:note.food',
  text: '飲食',
  desc: '飲食',
  descI18nKey: 'client_mgmt:mealDesc.food'
}), _defineProperty(_RECORD_FILTERS, NoteType.MoveNote, {
  noteType: NoteType.MoveNote,
  i18n: 'client_mgmt:note.move',
  text: '運動',
  desc: '運動描述',
  descI18nKey: 'client_mgmt:recordTypeSubTitle.move'
}), _defineProperty(_RECORD_FILTERS, "body", {
  i18n: 'client_mgmt:toDoFilter.body',
  text: '身體數據',
  desc: '身體數據'
}), _defineProperty(_RECORD_FILTERS, NoteType.WaterNote, {
  i18n: 'client_mgmt:note.water',
  noteType: NoteType.WaterNote,
  text: '飲水'
}), _defineProperty(_RECORD_FILTERS, NoteType.LifeNote, {
  i18n: 'client_mgmt:note.life',
  noteType: NoteType.LifeNote,
  text: '生活',
  desc: '生活/廁所描述',
  descI18nKey: 'client_mgmt:recordTypeSubTitle.stool'
}), _defineProperty(_RECORD_FILTERS, NoteType.StoolNote, {
  i18n: 'client_mgmt:note.stool',
  noteType: NoteType.StoolNote,
  text: '上廁所',
  desc: '生活/廁所描述',
  descI18nKey: 'client_mgmt:recordTypeSubTitle.stool'
}), _RECORD_FILTERS);
export var CATEGORY_MATCHERS = (_CATEGORY_MATCHERS = {}, _defineProperty(_CATEGORY_MATCHERS, TODO_FILTERS.unfinished, function (todo) {
  return !todo.done;
}), _defineProperty(_CATEGORY_MATCHERS, TODO_FILTERS.diet, function (todo) {
  return todo.type === TODO_TYPES.diet.key;
}), _defineProperty(_CATEGORY_MATCHERS, TODO_FILTERS.body, function (todo) {
  return todo.type === TODO_TYPES.body.key;
}), _defineProperty(_CATEGORY_MATCHERS, TODO_FILTERS.other, function (todo) {
  return todo.type !== TODO_TYPES.body.key && todo.type !== TODO_TYPES.diet.key;
}), _CATEGORY_MATCHERS);